import clsx from 'clsx';
import { FacetItemModel } from 'types/filter-types';

const FilterByRegion = (props: {
	alternateDisplay?: boolean;
	item: FacetItemModel;
	facetId: string;
	onChange: (facetId: string, id: string, active: boolean) => void;
	className?: string;
}) => {
	const { facetId, item, onChange, alternateDisplay, className } = props;

	const handleClick = () => {
		onChange(facetId, item.id, !item.active);
	};
	return (
		<li
			className={clsx(
				'pb-3',
				item.active && 'border-blue border-b-2',
				className
			)}
		>
			<button
				type="button"
				name={`${facetId}-${item.id}`}
				id={`${facetId}-${item.id}`}
				onClick={handleClick}
				className="btn-filter-region"
			>
				<span>
					{item.name} <span className="text-black">({item.count})</span>
				</span>
			</button>
		</li>
	);
};

export default FilterByRegion;
